import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { ReactNode } from 'react';

type InternalNoteProps = {
  children?: ReactNode;
  // Opt in for a note that appears in place of an async result (an empty
  // list, a dead end): role='status' has a screen reader announce it as it
  // renders. Static advisory notes keep the default and are read in place.
  live?: boolean;
};

export default function InternalNote({
  children = null,
  live = false
}: InternalNoteProps) {
  return (
    <div
      role={live ? 'status' : undefined}
      className='w-full rounded-lg bg-yellow-50 px-4 py-3 text-yellow-700 shadow'
    >
      <div className='flex gap-2'>
        <InformationCircleIcon className='h-5 w-5 flex-shrink-0' />
        <div className='grow text-sm'>{children}</div>
      </div>
    </div>
  );
}
